export const LOAD_PROFILE = 'LOAD_PROFILE';
export const SEARCH_PROFILES = 'SEARCH_PROFILES';
export const RESET_PROFILE_STATE = 'RESET_PROFILE_STATE';
export const RESET_SEARCH_PROFILES = 'RESET_SEARCH_PROFILES';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const CREATE_PROFILE = 'CREATE_PROFILE';
export const CREATE_REQUIRED_PROFILE = 'CREATE_REQUIRED_PROFILE';
export const UPLOAD_PROFILE_IMAGE = 'UPLOAD_PROFILE_IMAGE';
export const CONFIRM_PHONE_NUMBER = 'CONFIRM_PHONE_NUMBER';
export const CONFIRM_VERIFICATION_CODE = 'CONFIRM_VERIFICATION_CODE';
export const SEND_FEEDBACK = 'SEND_FEEDBACK';
export const IMAGE_FILE_TOO_BIG = 'IMAGE_FILE_TOO_BIG';

export function loadProfileAction(profileId) {
  return {
    type: LOAD_PROFILE,
    payload: { profileId }
  };
}

export function searchProfilesAction(searchValue, slug = null) {
  return {
    type: SEARCH_PROFILES,
    payload: { searchValue, slug }
  };
}

export function resetSearchProfilesAction() {
  return {
    type: RESET_SEARCH_PROFILES,
  };
}

export function updateProfileAction(slug, profileData) {
  return {
    type: UPDATE_PROFILE,
    payload: { slug, profileData }
  };
}

export function createRequiredProfileAction(slug, profileData) {
  return {
    type: CREATE_REQUIRED_PROFILE,
    payload: { slug, profileData }
  };
}

export function createProfileAction(slug, profileData) {
  return {
    type: CREATE_PROFILE,
    payload: { slug, profileData }
  };
}

export function confirmPhoneNumberAction(values) {
  return {
    type: CONFIRM_PHONE_NUMBER,
    payload: { values }
  };
}

export function sendFeedbackAction(values) {
  return {
    type: SEND_FEEDBACK,
    payload: { values }
  };
}

export function confirmVerificationCodeAction(values) {
  return {
    type: CONFIRM_VERIFICATION_CODE,
    payload: { values }
  };
}

export function uploadProfileImageAction(image) {
  return {
    type: UPLOAD_PROFILE_IMAGE,
    payload: { image }
  };
}

export function imageFileTooBigAction() {
  return {
    type: IMAGE_FILE_TOO_BIG,
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/profile.actions.js